import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaLifeRing } from 'react-icons/fa';

const BRAND = {
  activeRed: '#D52B1E',
  navIdleText: '#0f172a',
  navIdleIcon: '#0f172a',
};

const navBarFillTransition =
  'transform 0.45s cubic-bezier(0.2, 0.85, 0.36, 1), opacity 0.28s cubic-bezier(0.2, 0.85, 0.36, 1)';

const HelpNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.82rem;
  padding: 0.78rem 1rem 0.78rem 1.08rem;
  margin: 0.2rem 0.52rem 0.2rem 0;
  color: ${BRAND.navIdleText};
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 500;
  position: relative;
  border-radius: 0 999px 999px 0;
  overflow: hidden;
  isolation: isolate;

  & > * {
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: ${BRAND.activeRed};
    transform: scaleX(0);
    transform-origin: left center;
    z-index: 0;
    opacity: 0;
    transition: ${navBarFillTransition};
    box-shadow: 0 4px 16px rgba(213, 43, 30, 0.4);
  }

  .nav-icon {
    width: 23px;
    height: 23px;
    flex-shrink: 0;
    color: ${BRAND.navIdleIcon};
    transition: color 0.2s ease, opacity 0.2s ease, filter 0.2s ease;
  }

  &:hover::before,
  &.active::before {
    opacity: 1;
    transform: scaleX(1);
  }

  &:hover {
    color: #fff;
  }

  &.active {
    color: #fff;
    font-weight: 600;
  }

  &:hover .nav-item-label,
  &.active .nav-item-label {
    color: #fff;
  }

  &:hover .nav-icon,
  &.active .nav-icon {
    color: #fff;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.15));
  }

  &:focus-visible {
    outline: 2px solid #043663;
    outline-offset: 2px;
  }
`;

const NavItemLabel = styled.span.attrs({ className: 'nav-item-label' })`
  position: relative;
  z-index: 1;
  flex: 1;
  min-width: 0;
  color: inherit;
`;

export default function HelpSidebarLink({ to, onNavigate, onClick }) {
  const { t } = useTranslation();

  return (
    <HelpNavLink
      to={to}
      end
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;
        onNavigate?.();
      }}
    >
      <FaLifeRing className="nav-icon" aria-hidden />
      <NavItemLabel>{t('phase2.playerHelpWizard.navLabel')}</NavItemLabel>
    </HelpNavLink>
  );
}
